export const parseHexColor = (hex: string) => {
  hex = hex.replace('#', '')

  if (hex.length === 3) {
    // #RGB format
    return {
      r: parseInt(hex[0] + hex[0], 16),
      g: parseInt(hex[1] + hex[1], 16),
      b: parseInt(hex[2] + hex[2], 16),
      a: 1,
    }
  } else if (hex.length === 4) {
    // #RGBA format
    return {
      r: parseInt(hex[0] + hex[0], 16),
      g: parseInt(hex[1] + hex[1], 16),
      b: parseInt(hex[2] + hex[2], 16),
      a: parseInt(hex[3] + hex[3], 16) / 255,
    }
  } else if (hex.length === 6) {
    // #RRGGBB format
    return {
      r: parseInt(hex.substring(0, 2), 16),
      g: parseInt(hex.substring(2, 4), 16),
      b: parseInt(hex.substring(4, 6), 16),
      a: 1,
    }
  } else if (hex.length === 8) {
    // #RRGGBBAA format
    return {
      r: parseInt(hex.substring(0, 2), 16),
      g: parseInt(hex.substring(2, 4), 16),
      b: parseInt(hex.substring(4, 6), 16),
      a: parseInt(hex.substring(6, 8), 16) / 255,
    }
  } else {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 1,
    }
  }
}
